"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GtmAnalytics = /*#__PURE__*/function () {
  // eslint-disable-next-line no-console
  function GtmAnalytics() {
    var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : console.log;

    _classCallCheck(this, GtmAnalytics);

    this.logger = logger;
  }

  _createClass(GtmAnalytics, [{
    key: "sendEvent",
    value: function sendEvent(category, action, label) {
      var layers = ["dataLayer"];

      if (typeof window === "undefined") {
        return;
      } // Iterate over all potential dataLayer variables and check if they exist


      for (var _i = 0, _layers = layers; _i < _layers.length; _i++) {
        var layer = _layers[_i];

        if (typeof window[layer] !== "undefined") {
          // Send the event into GTM
          window[layer].push({
            event: "analyticsEvent",
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: null,
            eventNonInt: false
          });
        }
      }
    }
  }]);

  return GtmAnalytics;
}();

var _default = GtmAnalytics;
exports["default"] = _default;